// extracted by mini-css-extract-plugin
export default {"root":"PlasmicSignOutButton_root__SWGDQ","text":"PlasmicSignOutButton_text__spFhK"};